import { render, staticRenderFns } from "./SmsInput.vue?vue&type=template&id=5425b984"
import script from "./SmsInput.vue?vue&type=script&lang=js"
export * from "./SmsInput.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports